import { BrowserView } from 'components/DeviceDetect'
import CustomSlider from 'components/Slider'
import categoryUrl from 'helpers/categoryUrl'
import React, { Fragment } from 'react'
import {
  TopCategoryItem,
  TopCategoryItemCont,
  TopCategorySlide,
} from 'style/AllCategory.style'

export default function InnerPageTiles(props) {
  const { tiles } = props

  if (!Array.isArray(tiles)) return null

  const Tiles = tiles.map(tile => {
    return (
      <TopCategoryItem key={tile.id} to={categoryUrl(tile.slug)}>
        <img src={tile.image} alt={tile.title} />
        <p>{tile.title}</p>
      </TopCategoryItem>
    )
  })

  return (
    <Fragment>
      <TopCategoryItemCont>
        <CustomSlider settings={{ infinite: false }}>
          <TopCategorySlide>{Tiles}</TopCategorySlide>
        </CustomSlider>
      </TopCategoryItemCont>
      <BrowserView>
        <TopCategoryItemCont className="desktop-top-category">
          {Tiles}
        </TopCategoryItemCont>
      </BrowserView>
    </Fragment>
  )
}
